// Dirección de entrega del checkout (envío a domicilio con Correo Argentino).
// Los nombres de provincia son los de videocallshop-api/helpers/argentina.js:
// la API deriva el código de Correo del nombre, así que se manda uno de estos.
export const PROVINCES = [
    {
        name: 'CABA',
        aliases: [
            'ciudad autonoma de buenos aires',
            'capital federal',
            'ciudad de buenos aires',
        ],
    },
    { name: 'Buenos Aires' },
    { name: 'Catamarca' },
    { name: 'Chaco' },
    { name: 'Chubut' },
    { name: 'Córdoba' },
    { name: 'Corrientes' },
    { name: 'Entre Ríos' },
    { name: 'Formosa' },
    { name: 'Jujuy' },
    { name: 'La Pampa' },
    { name: 'La Rioja' },
    { name: 'Mendoza' },
    { name: 'Misiones' },
    { name: 'Neuquén' },
    { name: 'Río Negro' },
    { name: 'Salta' },
    { name: 'San Juan' },
    { name: 'San Luis' },
    { name: 'Santa Cruz' },
    { name: 'Santa Fe' },
    { name: 'Sgo. del Estero', aliases: ['santiago del estero'] },
    {
        name: 'Tierra del Fuego',
        aliases: ['tierra del fuego, antartida e islas del atlantico sur'],
    },
    { name: 'Tucumán' },
];

const normalize = (value) =>
    String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/^provincia de\s+/, '')
        .trim();

// El nombre que devuelve Google ("Provincia de Santa Fe", "Ciudad Autónoma de
// Buenos Aires") llevado a uno de la lista; '' si no coincide con ninguno.
export const provinceNameFor = (value) => {
    const n = normalize(value);
    if (!n) return '';
    const hit = PROVINCES.find(
        (p) =>
            normalize(p.name) === n ||
            (p.aliases || []).some((a) => normalize(a) === n)
    );
    return hit ? hit.name : '';
};

// Correo cotiza con los 4 dígitos: "S2000DKC" / "S2000" / "2000" -> "2000".
export const normalizePostalCode = (value) => {
    const m = String(value || '')
        .trim()
        .match(/^[A-Za-z]?(\d{4})[A-Za-z]{0,3}$/);
    return m ? m[1] : null;
};

// Un sessionToken de Google Places por cada búsqueda de dirección (se reusa
// en el details y se renueva después de elegir).
export const newSessionToken = () => {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

export const EMPTY_ADDRESS = {
    streetName: '',
    streetNumber: '',
    floor: '',
    apartment: '',
    city: '',
    province: '',
    postalCode: '',
};

export const isAddressComplete = (address) =>
    Boolean(
        address &&
            address.streetName.trim() &&
            address.streetNumber.trim() &&
            address.city.trim() &&
            address.province &&
            normalizePostalCode(address.postalCode)
    );
